<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
@if (layout === 'empty') {
    <empty-layout></empty-layout>
}

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Fidelity app layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
@if (layout === 'fidelity-app') {
    <fidelity-app-layout></fidelity-app-layout>
}
